<template>
  <fragment>
    <nav-mobile-inline-submenu v-for="(category, key) in getFilteredCategories" :key="key" :parentId="submenuId"
      :submenuId="`category-${category.id}`" :expandedSubmenu="expandedSubmenu" :expandedChanged="expandedChanged">
      <template v-slot:title>
        {{ category.title }}
      </template>
      <template v-slot:entries>
        <nav-mobile-inline-submenu v-show="expandedSubmenu === submenuId"
          v-for="(childCategory, key2) in category.children" :key="key2" :parentId="`category-${category.id}`"
          :submenuId="`category-${childCategory.id}`" :expandedSubmenu="expandedSubmenu"
          :expandedChanged="expandedChanged">
          <template v-slot:title>
            {{ childCategory.title }}
          </template>
          <template v-slot:entries>
            <nav-categorized-products v-show="`category-${childCategory.id}` === expandedSubmenu"
              :expanded="`category-${childCategory.id}` === expandedSubmenu" :category="childCategory"
              :indexPrefix="`category-${category.id}`" itemClass="mobile" />
          </template>
        </nav-mobile-inline-submenu>
      </template>
    </nav-mobile-inline-submenu>
  </fragment>
</template>

<script>
import products from '@/components/products';
import NavMobileInlineSubmenu from './NavMobileInlineSubmenu.vue';
import NavCategorizedProducts from './NavCategorizedProducts.vue';
import mixins from '@/mixins';
import { mapGetters } from 'vuex';
import { Fragment } from 'vue-frag';

export default {
  name: 'NavMobileProductCategories',
  mixins: [
    mixins.supportedFeatures
  ],
  props: {
    submenuId: {
      type: String,
      required: true,
    },
    expandedSubmenu: {
      type: String,
      required: false,
    },
    expandedChanged: {
      type: Function,
      required: true,
    },
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapGetters(products.store.namespace, [
      'getFilteredCategories'
    ]),
  },
  components: {
    Fragment,
    NavMobileInlineSubmenu,
    NavCategorizedProducts,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import '@/assets/base/_typography.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';


// Spacing, font and color
.el-menu-item {
  @extend h4;
  font-family: $font-family-headings;
  line-height: 40px;
  color: $--color-menu-gray;
  border-bottom: 1px solid $--color-grayscale-2 !important;

  &:focus-visible {
    text-decoration: underline;
  }
}


.el-menu-item-group {

  &>.el-menu-item-group__title {
    @extend h4;
    font-family: $font-family-headings;
    line-height: 40px;
    color: $--color-secondary;
    padding: 0.5rem 0.5rem 0rem 1rem !important;
  }

  &>ul {
    &>.el-menu-item {
      line-height: 22px;
      white-space: normal;
      padding: 0.5rem 0 1rem 3rem !important;
      margin: 0.5rem 0 0 0 !important;
      height: auto;
    }
  }
}
</style>
